import { HttpErrorResponse } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ContaDreService } from '@app/modules/conta-dre/services/conta-dre.service';
import { INaturezaFinanceira } from '@app/modules/natureza_financeira/model/natureza_financeira.model';
import { NaturezaFinanceiraService } from '@app/modules/natureza_financeira/services/natureza_financeira.service';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
  SELECT
} from '@app/shared/components';
import { Utils } from '@app/shared/helpers/utils';
import { Dialog } from 'primeng/dialog';
import { filter } from 'rxjs/operators';
import {
  CustomValidators,
  ErroMessages,
  IErroMessages,
  TokenService
} from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-fast-natureza-financeira',
  templateUrl: './fast-natureza-financeira.component.html',
  styleUrls: ['./fast-natureza-financeira.component.scss'],
  providers: [NaturezaFinanceiraService, ContaDreService]
})
export class FastNaturezaFinanceiraComponent implements OnInit, AfterViewInit {
  @ViewChild('fastNatFin') fastNatFin: Dialog;
  form: UntypedFormGroup;
  tipo: string;
  apropriacao: string;

  loading = false;

  naturezaTipos = [
    { viewValue: 'Despesa', value: 'DESPESA' },
    { viewValue: 'Receita', value: 'RECEITA' }
  ] as SELECT[];

  apropriacaoTipos = [
    { viewValue: 'Débito', value: 'DEBITO' },
    { viewValue: 'Crédito', value: 'CREDITO' }
  ] as SELECT[];

  constructor(
    protected fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { entity: INaturezaFinanceira },
    protected entityService: NaturezaFinanceiraService,
    protected contaDreService: ContaDreService,
    public matSnackBar: MatSnackBar,
    public matDialog: MatDialog,
    public router: Router,
    protected dialogRef: MatDialogRef<FastNaturezaFinanceiraComponent>,
    protected tokenService: TokenService
  ) {
    this.tipo = data.entity.tipo;
    this.apropriacao = data.entity.apropriacao;
  }

  ngAfterViewInit(): void {
    this.fastNatFin.maximize();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      descricao: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ],
      periodicidade: [false, [Validators.required]],
      tipo: [
        this.tipo
          ? this.naturezaTipos.find(op => op.value === this.tipo)
          : this.naturezaTipos[1],
        [Validators.required]
      ],
      apropriacao: [
        this.apropriacao
          ? this.apropriacaoTipos.find(op => op.value === this.apropriacao)
          : this.apropriacaoTipos[1],
        [Validators.required]
      ],
      natureza_financeira: [
        null,
        [CustomValidators.typeIs('object'), CustomValidators.isEmptyValue()]
      ]
      // conta_dre: [
      //   null,
      //   [CustomValidators.typeIs('object'), CustomValidators.isEmptyValue()]
      // ]
    });
    this.validateForm();
  }

  onSubmit() {
    this.loading = true;
    var entity = {
      domain_id: this.tokenService.getDomain().id,
      ...this.form.value
    } as INaturezaFinanceira;
    entity = Utils.trimAttributes(entity);
    entity.tipo = this.form.value.tipo.value;
    entity.apropriacao = this.form.value.apropriacao.value;
    entity.natureza_financeira_id = this.form.value.natureza_financeira
      ? this.form.value.natureza_financeira.id
      : null;
    // entity.conta_dre_id = this.form.value.conta_dre
    //   ? this.form.value.conta_dre.id
    //   : null;
    delete entity.natureza_financeira;
    // delete entity.conta_dre;

    if (this.form.valid) {
      this.entityService
        .insert(entity)
        .pipe(filter(result => !!result))
        .subscribe(
          formPgmt => {
            this.loading = false;
            this.dialogRef.close(formPgmt);
            this.matSnackBar.open(
              'Natureza financeira cadastrada com sucesso.',
              'X',
              {
                duration: 2000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['msg-success']
              }
            );
          },
          (err: HttpErrorResponse) => {
            this.displayError(err);
            this.loading = false;
          }
        );
    }
  }

  actionFnCheckEntityExist(control: AbstractControl) {
    Utils.checkIfValueExist(
      control,
      this.entityService,
      'descricao',
      this.tokenService.getDomain().id,
      null,
      this.form
    );
  }

  markAllControlsAsDirty() {
    Object.keys(this.form.controls).forEach(controlKey => {
      controlKey = String(controlKey);
      const control = this.form.get(controlKey);
      if (!control || control.valid) return;
      control.markAsDirty();
    });
  }

  validateForm() {
    this.form.markAllAsTouched();
    this.markAllControlsAsDirty();
  }

  displayError(err: HttpErrorResponse, showDefaultMsg = false) {
    const errorMsg = new ErroMessages({
      route: this.router.url,
      router: this.router,
      matSnackBar: this.matSnackBar,
      httpError: err,
      showDefaultMsg: showDefaultMsg,
      loginService: null,
      tokenService: this.tokenService,
      dialogComponent: ConfirmDialogComponent,
      matDialog: this.matDialog,
      dialogData: {
        config: {
          data: {
            title: 'Aviso - Erro ao realizar operação',
            bodyMessage: err.error,
            icon: 'warning',
            icon_color: 'accent',
            singleBtn: true
          } as ConfirmDialogData,
          disableClose: true,
          width: '500px'
        } as MatDialogConfig<any>
      }
    } as IErroMessages);
    errorMsg.showMessageObject(err.error);
    // errorMsg.checkError();
  }
}
